const isDigit = (character: string): boolean =>
  character >= '0' && character <= '9';

const idFromSlug = (slug?: string | null): number | undefined => {
  if (!slug) {
    return undefined;
  }

  let start = slug.length;
  while (start > 0 && isDigit(slug[start - 1])) {
    start -= 1;
  }

  const digits = slug.slice(start);
  const id = Number(digits);

  return digits && Number.isSafeInteger(id) && id > 0 ? id : undefined;
};

export default idFromSlug;
